/** Pastki varaq (demo `.lsh/.lsb`): til tanlash, ovoz yo'q, progressni tozalash kabi dialoglar uchun. */
import { useState, type ReactNode } from 'react';
import { LANG } from '../data';
import { Ic } from './Icon';

export function useSheet() {
  const [node, setNode] = useState<ReactNode>(null);
  const close = () => setNode(null);
  const open = (content: ReactNode) => setNode(
    <div className="lsh" onClick={(e) => { if (e.target === e.currentTarget) close(); }}>{content}</div>,
  );
  return { node, open, close };
}

export function SheetBox({ title, titleColor, onClose, children, label }: { title: string; titleColor?: string; onClose: () => void; children: ReactNode; label?: string }) {
  return (
    <div className="lsb" role="dialog" aria-label={label ?? title}>
      <div className="between">
        <b className="t16b" style={{ fontSize: 18, color: titleColor }}>{title}</b>
        <button className="sq2" onClick={onClose} aria-label="Yopish"><Ic n="x" size={18} /></button>
      </div>
      {children}
    </div>
  );
}

export function NoVoiceSheet({ onClose }: { onClose: () => void }) {
  const ru = LANG === 'ru';
  return (
    <SheetBox title={`${ru ? 'Rus' : 'Ingliz'} tili ovozi topilmadi`} onClose={onClose} label="Ovoz topilmadi">
      <span className="t13">Qurilmangizda {ru ? 'rus' : 'ingliz'} tili ovozi oʻrnatilmagan, shuning uchun soʻzlar notoʻgʻri talaffuz qilinmasligi uchun ovoz oʻchirildi. Oʻrnating:</span>
      <div className="col g8 t13" style={{ color: 'var(--ink)', fontWeight: 600 }}>
        <span>• <b>Android:</b> Sozlamalar → Til va kiritish → Matnni nutqqa → Google → {ru ? 'Русский' : 'English'} ovozini yuklab oling</span>
        <span>• <b>iPhone:</b> Settings → Accessibility → Spoken Content → Voices → {ru ? 'Russian' : 'English'}</span>
        <span>• <b>Windows:</b> Sozlamalar → Vaqt va til → Nutq → Ovoz qoʻshish → {ru ? 'Русский' : 'English'}</span>
        <span>• Yoki sahifani <b>Google Chrome</b>da oching — unda rus ovozi tayyor boʻladi</span>
      </div>
      <button className="btn" style={{ height: 46 }} onClick={onClose}>Tushunarli</button>
    </SheetBox>
  );
}
